import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskV2NavigationTabsComponent } from './task-v2-navigation-tabs/task-v2-navigation-tabs.component';
import { FiAppTextSharedModule } from '../shared/app-text';
import { FiTabsModule } from '../utilities/tabs/tabs.module';
import { UIRouterModule } from '@uirouter/angular';
import { TaskV2States } from './task-v2-states';
import { FiStateSrefModule } from '@fi-shared/fi-state-proxy/state-sref/state-sref.module';
import { MatButtonModule } from '@angular/material/button';
import { TaskV2ReportStates } from './task-v2-report-states';
import { FiTaskV2ListModule } from './fi-task-v2-list/fi-task-v2-list.module';
import { FiTaskV2EditModule } from './fi-task-v2-edit/fi-task-v2-edit.module';
import { FiTaskV2DetailsModule } from './fi-task-v2-details/fi-task-v2-details.module';
import { FiProfileIconStackedModule } from '@fi-shared/fi-profile-icon-stacked/fi-profile-icon-stacked.module';
import { FiTaskV2ArchivedListModule } from './fi-task-v2-archived-list/fi-task-v2-archived-list.module';
import { FiTaskV2ReportModule } from './fi-task-v2-report/fi-task-v2-report.module';
import { FiTaskV2Service } from '@fi-app/task-v2/fi-task-v2.service';
import { FiTaskV2SyncService } from '@fi-app/task-v2/fi-task-v2-sync.service';
import { FiTaskV2HelperService } from '@fi-app/task-v2/fi-task-v2-helper.service';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    imports: [
        UIRouterModule.forChild(TaskV2States),
        UIRouterModule.forChild(TaskV2ReportStates),
        CommonModule,
        FiAppTextSharedModule,
        FiTabsModule,
        FiStateSrefModule,
        MatButtonModule,
        FiTaskV2ListModule,
        FiTaskV2EditModule,
        FiTaskV2DetailsModule,
        FiProfileIconStackedModule,
        FiTaskV2ArchivedListModule,
        FiTaskV2ReportModule,
        MatIconModule,
    ],
    declarations: [TaskV2NavigationTabsComponent],
    providers: [FiTaskV2Service, FiTaskV2SyncService, FiTaskV2HelperService],
})
export class TaskV2Module {}
